import api from '../api'
import {
  AddEmployeePageSetupConfig,
  InflowPageSetupConfig,
  PageSetupResponse,
} from '../../types/settings/pageSetupTypes'

export const getInflowPageSetup = async (): Promise<PageSetupResponse<InflowPageSetupConfig>> => {
  const response = await api.get<PageSetupResponse<InflowPageSetupConfig>>('/organization/page-setups/inflow/')
  return response.data
}

export const updateInflowPageSetup = async (
  config: InflowPageSetupConfig,
): Promise<PageSetupResponse<InflowPageSetupConfig>> => {
  const response = await api.put<PageSetupResponse<InflowPageSetupConfig>>('/organization/page-setups/inflow/', { config })
  return response.data
}

export const getAddEmployeePageSetup = async (): Promise<PageSetupResponse<AddEmployeePageSetupConfig>> => {
  const response = await api.get<PageSetupResponse<AddEmployeePageSetupConfig>>('/organization/page-setups/add-employee/')
  return response.data
}

export const updateAddEmployeePageSetup = async (
  config: AddEmployeePageSetupConfig,
): Promise<PageSetupResponse<AddEmployeePageSetupConfig>> => {
  const response = await api.put<PageSetupResponse<AddEmployeePageSetupConfig>>('/organization/page-setups/add-employee/', { config })
  return response.data
}
